import type { FulfillmentOrderLine } from '@/infrastructure/FulfillmentAdminClient';

/** Show originals only when variation-pack recalculation changed the SKU or quantity (SSD-7267). */
export const lineRecalculated = (line: FulfillmentOrderLine): boolean =>
  (line.originalSku != null && String(line.originalSku) !== String(line.sku)) ||
  (line.originalQuantity != null && Number(line.originalQuantity) !== Number(line.totalQuantity));

/** Explain warehouse units without guessing a pack size from the product name. */
export const variationPackDisplay = (
  line: FulfillmentOrderLine,
): { orderedSku: string; math: string | null } | null => {
  if (!lineRecalculated(line) || !line.originalSku?.trim() || String(line.originalSku) === String(line.sku)) {
    return null;
  }
  const ordered = Number(line.originalQuantity ?? line.qtyOrdered);
  const total = Number(line.totalQuantity);
  const packSize = total / ordered;
  const valid = Number.isSafeInteger(ordered) && ordered > 0 && Number.isSafeInteger(packSize) && packSize > 0;
  return {
    orderedSku: line.originalSku,
    math: valid ? `= ${ordered} × ${packSize} ${packSize === 1 ? 'pack' : 'packs'}` : null,
  };
};
